module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vurin5-bb6c35672388cb22c681871b0d37ecb6.jpg";